
// import './HomeCollectionCss/HomeCollection.css';

import ServiceHeader from '../../ServiceComponents/ServiceHeader';

export default function CollectionFirstSec() {
    return (
        <>
            <ServiceHeader
                childClass="collectionUpperSection"
                breadcrumb={<> Home Collection</>}
                title="Home Collection"
            />

        </>
    )
}